import { useCreateCtx } from '@cleartax/wg-library-hooks';
import { Dispatch, SetStateAction } from 'react';

interface IPaytaxCalculatorContext {
  financialYear: string;
  setFinancialYear: Dispatch<SetStateAction<string>>;
  financialYearCalc: string;
  setFinancialYearCalc: Dispatch<SetStateAction<string>>;
}

export const [usePaytaxCalcContext, PaytaxCalculatorProvider] =
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useCreateCtx<IPaytaxCalculatorContext>();
